import { memo } from 'react';
import { useIntl } from 'react-intl';
import { HeroSquare } from '@cbhq/cds-web/illustrations/HeroSquare';
import { VStack } from '@cbhq/cds-web/layout';
import { TextBody, TextTitle3 } from '@cbhq/cds-web/typography';

import { SingleColumnLayout } from ':fat/components/PageLayout/SingleColumnLayout';

import { messages } from './messages';

export const ServiceUnavailablePage = memo(function ServiceUnavailablePage() {
  const { formatMessage } = useIntl();

  return (
    <SingleColumnLayout>
      <VStack alignItems="center" justifyContent="center" spacing={4} maxWidth={450}>
        <HeroSquare name="errorWeb500" dimension="240x240" />
        <VStack spacingVertical={4} alignItems="center">
          <TextTitle3 as="p">{formatMessage(messages.title)}</TextTitle3>
          <TextBody as="p" align="center" color="foregroundMuted" spacingTop={1}>
            {formatMessage(messages.description)}
          </TextBody>
        </VStack>
      </VStack>
    </SingleColumnLayout>
  );
});
